import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import Axios from "axios";
import { errors } from "@ideal-postcodes/core-interface";
var IdealPostcodesError = errors.IdealPostcodesError;
/**
 * Converts a Got header object to one that can be used by the client
 *
 * @hidden
 */

export var toHeader = function toHeader(gotHeaders) {
  return Object.keys(gotHeaders).reduce(function (headers, key) {
    var val = gotHeaders[key];

    if (typeof val === "string") {
      headers[key] = val;
    } else if (Array.isArray(val)) {
      headers[key] = val.join(",");
    }

    return headers;
  }, {});
};
/**
 * Adapts got responses to a format consumable by core-interface
 *
 * @hidden
 */

var toHttpResponse = function toHttpResponse(httpRequest, response) {
  return {
    httpRequest: httpRequest,
    body: response.data,
    httpStatus: response.status || 0,
    header: toHeader(response.headers),
    metadata: {
      response: response
    }
  };
};
/**
 * Catch non-response errors (e.g. network failure, DNS failure, timeout)
 * wrap in our Error class and return
 *
 * @hidden
 */


var handleError = function handleError(error) {
  var idpcError = new IdealPostcodesError({
    message: "[".concat(error.name, "] ").concat(error.message),
    httpStatus: 0,
    metadata: {
      axios: error
    }
  });
  return Promise.reject(idpcError);
}; // Don't throw errors for any HTTP status code
// Allow core-interface to absorb these and emit own errors


var validateStatus = function validateStatus() {
  return true;
};
/**
 * Agent
 *
 * @hidden
 */


export var Agent = /*#__PURE__*/function () {
  function Agent() {
    _classCallCheck(this, Agent);

    this.Axios = Axios.create({
      validateStatus: validateStatus
    });
  }

  _createClass(Agent, [{
    key: "requestWithBody",
    value: function requestWithBody(httpRequest) {
      var body = httpRequest.body,
          method = httpRequest.method,
          timeout = httpRequest.timeout,
          url = httpRequest.url,
          header = httpRequest.header,
          query = httpRequest.query;
      return this.Axios.request({
        url: url,
        method: method,
        headers: header,
        params: query,
        data: body,
        timeout: timeout
      }).then(function (response) {
        return toHttpResponse(httpRequest, response);
      }).catch(handleError);
    }
  }, {
    key: "request",
    value: function request(httpRequest) {
      var method = httpRequest.method,
          timeout = httpRequest.timeout,
          url = httpRequest.url,
          header = httpRequest.header,
          query = httpRequest.query;
      return this.Axios.request({
        url: url,
        method: method,
        headers: header,
        params: query,
        timeout: timeout
      }).then(function (response) {
        return toHttpResponse(httpRequest, response);
      }).catch(handleError);
    }
  }, {
    key: "http",
    value: function http(httpRequest) {
      if (httpRequest.body !== undefined) return this.requestWithBody(httpRequest);
      return this.request(httpRequest);
    }
  }]);

  return Agent;
}();